<template>
    <div class="chart--container chart--container-donut">
        <donut-chart :data="donut"
                :type="type"
                v-for="(donut, index) in chartData"
                :key="index"/>
    </div>
</template>

<script>
    import chartMixin from '../chart-mixin.js';
    import DonutChart from '../donut-chart/donut-chart';

    export default {
        components: {
            DonutChart,
        },
        mixins: [chartMixin],
        props: {
            type: {
                type: String,
                default: '',
            },
            data: {
                type: [String, Array],
                default: () => [],
            },
        },
    };
</script>
